/**
 * Guard function that checks if provided `input` is an Element.
 */
export function isElement(input) {
    return input && input instanceof Element;
}
//# sourceMappingURL=utilities-iselement.js.map